import { buildOptions, getEndPoints } from "../../../utils/api-call";
import { makeCall } from "../../../utils/request";
import * as storeUtils from "../../../utils/store-handler";
import { EventBus } from "@/event-bus";
import { EVENT_TOAST_MESSAGE, EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";
import * as emailTemplateConsts from "./constants";

export const state = {
  emailTemplates: [],
  emailTemplate: {},
  pagination: {
    count: 10,
    total: 0
  }
};

export const getters = {
  [emailTemplateConsts.GETTERS_LIST_EMAIL_TEMPLATES]: state => {
    return state.emailTemplates;
  },
  [emailTemplateConsts.GETTERS_EMAIL_TEMPLATE_PAGINATION]: state => {
    return state.pagination;
  },
  [emailTemplateConsts.GETTERS_EMAIL_TEMPLATE_DETAIL]: state => {
    return state.emailTemplate;
  }
};

export const actions = {
  [emailTemplateConsts.ACTION_GET_EMAIL_TEMPLATE_LIST]: (
    { commit },
    options
  ) => {
    makeCall(
      getEndPoints().email_template.getList,
      buildOptions("GET", options),
      commit
    ).then(
      response => {
        if (response.data) {
          commit(
            emailTemplateConsts.MUTATION_SET_EMAIL_TEMPLATE_LIST,
            response
          );
        }
      },
      response => {
        const error = storeUtils.handleErrorMessage(response);
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (error && error.message) || "Something went wrong"
        );
      }
    );
  },
  [emailTemplateConsts.ACTION_ADD_EMAIL_TEMPLATE]: ({ commit }, options) => {
    makeCall(
      getEndPoints().email_template.add,
      buildOptions("POST", options.data),
      commit
    ).then(
      response => {
        if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback(response);
        }
      },
      error => {
        if (error.response && error.response.data.error) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          options.errorHandling(storeUtils.handleErrorMessage(error));
        }
      }
    );
  },
  [emailTemplateConsts.ACTION_EDIT_EMAIL_TEMPLATE]: ({ commit }, options) => {
    makeCall(
      getEndPoints().email_template.edit.replace(":id", options.id),
      buildOptions("PUT", options.data),
      commit
    ).then(
      response => {
        if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback(response);
        }
      },
      error => {
        if (error.response && error.response.data.error) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          options.errorHandling(storeUtils.handleErrorMessage(error));
        }
      }
    );
  },
  [emailTemplateConsts.ACTION_GET_EMAIL_TEMPLATE_DETAIL]: ({ commit }, id) => {
    makeCall(
      getEndPoints().email_template.detail.replace(":id", id),
      buildOptions("GET", {}),
      commit
    ).then(
      response => {
        if (response.data) {
          commit(
            emailTemplateConsts.MUTATION_SET_EMAIL_TEMPLATE,
            response.data
          );
        }
      },
      response => {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      }
    );
  },
  [emailTemplateConsts.ACTION_SET_EMPTY_EMAIL_TEMPLATE]: ({ commit }) => {
    commit(emailTemplateConsts.MUTATION_SET_EMAIL_TEMPLATE, {});
  },
  [emailTemplateConsts.ACTION_GET_ALL_EMAIL_TEMPLATE]: (
    { commit, state, dispatch },
    include
  ) => {
    dispatch(emailTemplateConsts.ACTION_GET_EMAIL_TEMPLATE_LIST, {
      params: Object.assign({ limit: 0, flat: 1 }, include && { include })
    });
  }
};

export const mutations = {
  [emailTemplateConsts.MUTATION_SET_EMAIL_TEMPLATE_LIST]: (
    state,
    emailTemplates
  ) => {
    state.emailTemplates = emailTemplates.data;
    state.pagination =
      emailTemplates.meta && emailTemplates.meta.pagination
        ? {
            ...{
              count: emailTemplates.meta.pagination.count,
              total: emailTemplates.meta.pagination.total,
              itemsPerPage: emailTemplates.meta.pagination.per_page,
              totalPage: emailTemplates.meta.pagination.total_pages
            }
          }
        : state.pagination;
  },
  [emailTemplateConsts.MUTATION_SET_EMAIL_TEMPLATE]: (state, emailTemplate) => {
    state.emailTemplate = emailTemplate;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/email_template/index.js